var _a, _b;
export var BrandingColorType;
(function (BrandingColorType) {
    BrandingColorType["MAIN"] = "main";
    BrandingColorType["ACTION"] = "action";
    BrandingColorType["BACKGROUND"] = "background";
    BrandingColorType["CUSTOM"] = "custom";
})(BrandingColorType || (BrandingColorType = {}));
export var HelpcenterButtonType;
(function (HelpcenterButtonType) {
    HelpcenterButtonType["Primary"] = "primary";
    HelpcenterButtonType["Secondary"] = "secondary";
})(HelpcenterButtonType || (HelpcenterButtonType = {}));
export var HelpcenterPageType;
(function (HelpcenterPageType) {
    HelpcenterPageType[HelpcenterPageType["HOMEPAGE"] = 0] = "HOMEPAGE";
    HelpcenterPageType[HelpcenterPageType["CONTACT"] = 10] = "CONTACT";
    HelpcenterPageType[HelpcenterPageType["ARTICLE"] = 20] = "ARTICLE";
    HelpcenterPageType[HelpcenterPageType["ARTICLE_KNOWN_ISSUE"] = 21] = "ARTICLE_KNOWN_ISSUE";
    HelpcenterPageType[HelpcenterPageType["ARTICLE_FEATURE_REQUEST"] = 22] = "ARTICLE_FEATURE_REQUEST";
    HelpcenterPageType[HelpcenterPageType["FOLLOWED_ARTICLES"] = 23] = "FOLLOWED_ARTICLES";
    HelpcenterPageType[HelpcenterPageType["CATEGORIES"] = 30] = "CATEGORIES";
    HelpcenterPageType[HelpcenterPageType["CATEGORY"] = 31] = "CATEGORY";
    HelpcenterPageType[HelpcenterPageType["SUB_CATEGORIES"] = 32] = "SUB_CATEGORIES";
    HelpcenterPageType[HelpcenterPageType["SEARCH_RESULTS"] = 50] = "SEARCH_RESULTS";
    HelpcenterPageType[HelpcenterPageType["REQUEST_LIST"] = 60] = "REQUEST_LIST";
    HelpcenterPageType[HelpcenterPageType["REQUEST_PAGE"] = 70] = "REQUEST_PAGE";
    HelpcenterPageType[HelpcenterPageType["ERROR"] = 100] = "ERROR";
})(HelpcenterPageType || (HelpcenterPageType = {}));
export var HelpcenterSectionType;
(function (HelpcenterSectionType) {
    HelpcenterSectionType[HelpcenterSectionType["HERO"] = 0] = "HERO";
    // ACTION = 10,
    HelpcenterSectionType[HelpcenterSectionType["CATEGORIES"] = 20] = "CATEGORIES";
    HelpcenterSectionType[HelpcenterSectionType["CORE_CATEGORIES"] = 23] = "CORE_CATEGORIES";
    HelpcenterSectionType[HelpcenterSectionType["CORE_SUB_CATEGORIES"] = 25] = "CORE_SUB_CATEGORIES";
    HelpcenterSectionType[HelpcenterSectionType["CORE_ARTICLE"] = 30] = "CORE_ARTICLE";
    HelpcenterSectionType[HelpcenterSectionType["CORE_ARTICLE_FEATURE_REQUEST"] = 31] = "CORE_ARTICLE_FEATURE_REQUEST";
    HelpcenterSectionType[HelpcenterSectionType["CORE_ARTICLE_KNOWN_ISSUE"] = 32] = "CORE_ARTICLE_KNOWN_ISSUE";
    HelpcenterSectionType[HelpcenterSectionType["ARTICLE_LIST"] = 40] = "ARTICLE_LIST";
    HelpcenterSectionType[HelpcenterSectionType["CORE_ARTICLE_LIST"] = 45] = "CORE_ARTICLE_LIST";
    HelpcenterSectionType[HelpcenterSectionType["FOLLOWED_ARTICLES"] = 46] = "FOLLOWED_ARTICLES";
    HelpcenterSectionType[HelpcenterSectionType["CONTACT_FORM"] = 50] = "CONTACT_FORM";
    HelpcenterSectionType[HelpcenterSectionType["CORE_SEARCH_RESULTS"] = 60] = "CORE_SEARCH_RESULTS";
    HelpcenterSectionType[HelpcenterSectionType["CUSTOM"] = 70] = "CUSTOM";
    HelpcenterSectionType[HelpcenterSectionType["CORE_REQUEST_LIST"] = 80] = "CORE_REQUEST_LIST";
    HelpcenterSectionType[HelpcenterSectionType["CORE_REQUEST_PAGE"] = 90] = "CORE_REQUEST_PAGE";
    HelpcenterSectionType[HelpcenterSectionType["CORE_ERROR"] = 100] = "CORE_ERROR";
})(HelpcenterSectionType || (HelpcenterSectionType = {}));
export var ImageScale;
(function (ImageScale) {
    ImageScale["CONTAIN"] = "contain";
    ImageScale["ORIGINAL"] = "original";
    ImageScale["FIT_WIDTH"] = "fit-width";
    ImageScale["FIT_HEIGHT"] = "fit-height";
})(ImageScale || (ImageScale = {}));
export var HeroSectionLayout;
(function (HeroSectionLayout) {
    HeroSectionLayout["CENTER"] = "center";
    HeroSectionLayout["COMPACT"] = "compact";
    HeroSectionLayout["SIDE_BY_SIDE"] = "side-by-side";
})(HeroSectionLayout || (HeroSectionLayout = {}));
export var HeroSectionHeight;
(function (HeroSectionHeight) {
    HeroSectionHeight["SHORT"] = "short";
    HeroSectionHeight["TALL"] = "tall";
})(HeroSectionHeight || (HeroSectionHeight = {}));
export var HeroSectionAlignment;
(function (HeroSectionAlignment) {
    HeroSectionAlignment["RIGHT"] = "right";
    HeroSectionAlignment["LEFT"] = "left";
})(HeroSectionAlignment || (HeroSectionAlignment = {}));
export var CategoriesLayout;
(function (CategoriesLayout) {
    CategoriesLayout["LIST"] = "list";
    CategoriesLayout["CARDS"] = "cards";
    CategoriesLayout["DETAILED_LIST"] = "detailed-list";
})(CategoriesLayout || (CategoriesLayout = {}));
export var RelatedArticlesLayout;
(function (RelatedArticlesLayout) {
    RelatedArticlesLayout["LIST"] = "list";
    RelatedArticlesLayout["CARDS"] = "cards";
})(RelatedArticlesLayout || (RelatedArticlesLayout = {}));
export var ArticleListLayout;
(function (ArticleListLayout) {
    ArticleListLayout["LIST"] = "list";
    ArticleListLayout["CARDS"] = "cards";
})(ArticleListLayout || (ArticleListLayout = {}));
export var VoteFeedbackMode;
(function (VoteFeedbackMode) {
    VoteFeedbackMode["CONTACT_MESSAGE"] = "contact-message";
    VoteFeedbackMode["FEEDBACK_MESSAGE"] = "feedback-message";
})(VoteFeedbackMode || (VoteFeedbackMode = {}));
export var itemsPerRowLayoutMap = (_a = {},
    _a[CategoriesLayout.LIST] = [2, 3],
    _a[CategoriesLayout.CARDS] = [2, 3, 4],
    _a[CategoriesLayout.DETAILED_LIST] = [3, 4],
    _a);
export var CustomerPortalFieldType;
(function (CustomerPortalFieldType) {
    CustomerPortalFieldType[CustomerPortalFieldType["SUBJECT"] = 10] = "SUBJECT";
    CustomerPortalFieldType[CustomerPortalFieldType["REPORTER"] = 20] = "REPORTER";
    CustomerPortalFieldType[CustomerPortalFieldType["CREATION_DATE"] = 30] = "CREATION_DATE";
    CustomerPortalFieldType[CustomerPortalFieldType["LAST_UPDATE_DATE"] = 40] = "LAST_UPDATE_DATE";
    CustomerPortalFieldType[CustomerPortalFieldType["LOCALE"] = 50] = "LOCALE";
    CustomerPortalFieldType[CustomerPortalFieldType["COMPANY"] = 60] = "COMPANY";
    CustomerPortalFieldType[CustomerPortalFieldType["PRIORITY"] = 70] = "PRIORITY";
    CustomerPortalFieldType[CustomerPortalFieldType["STATUS"] = 80] = "STATUS";
    CustomerPortalFieldType[CustomerPortalFieldType["CC_RECIPIENTS"] = 90] = "CC_RECIPIENTS";
    CustomerPortalFieldType[CustomerPortalFieldType["TICKET_ASSIGNEE"] = 100] = "TICKET_ASSIGNEE";
    CustomerPortalFieldType[CustomerPortalFieldType["TICKET_NUMBER"] = 110] = "TICKET_NUMBER";
})(CustomerPortalFieldType || (CustomerPortalFieldType = {}));
export var HelpcenterPageNames;
(function (HelpcenterPageNames) {
    HelpcenterPageNames["HOMEPAGE"] = "homePage";
    HelpcenterPageNames["CONTACT"] = "contactPage";
    HelpcenterPageNames["CATEGORIES"] = "categoriesPage";
    HelpcenterPageNames["SUB_CATEGORIES"] = "subCategoriesPage";
    HelpcenterPageNames["CATEGORY"] = "categoryPage";
    HelpcenterPageNames["ARTICLE"] = "articlePage";
    HelpcenterPageNames["ARTICLE_FEATURE_REQUEST"] = "featureRequestArticlePage";
    HelpcenterPageNames["ARTICLE_KNOWN_ISSUE"] = "knownIssueArticlePage";
    HelpcenterPageNames["SEARCH_RESULTS"] = "searchResultsPage";
    HelpcenterPageNames["ERROR"] = "errorPage";
    HelpcenterPageNames["REQUEST_LIST"] = "requestListPage";
    HelpcenterPageNames["REQUEST_PAGE"] = "requestPage";
    HelpcenterPageNames["FOLLOWED_ARTICLES"] = "followedArticlesPage";
})(HelpcenterPageNames || (HelpcenterPageNames = {}));
export var PageTypeToNameMap = (_b = {},
    _b[HelpcenterPageType.HOMEPAGE] = HelpcenterPageNames.HOMEPAGE,
    _b[HelpcenterPageType.CONTACT] = HelpcenterPageNames.CONTACT,
    _b[HelpcenterPageType.CATEGORIES] = HelpcenterPageNames.CATEGORIES,
    _b[HelpcenterPageType.SUB_CATEGORIES] = HelpcenterPageNames.SUB_CATEGORIES,
    _b[HelpcenterPageType.CATEGORY] = HelpcenterPageNames.CATEGORY,
    _b[HelpcenterPageType.ARTICLE] = HelpcenterPageNames.ARTICLE,
    _b[HelpcenterPageType.ARTICLE_FEATURE_REQUEST] = HelpcenterPageNames.ARTICLE_FEATURE_REQUEST,
    _b[HelpcenterPageType.ARTICLE_KNOWN_ISSUE] = HelpcenterPageNames.ARTICLE_KNOWN_ISSUE,
    _b[HelpcenterPageType.SEARCH_RESULTS] = HelpcenterPageNames.SEARCH_RESULTS,
    _b[HelpcenterPageType.ERROR] = HelpcenterPageNames.ERROR,
    _b[HelpcenterPageType.REQUEST_LIST] = HelpcenterPageNames.REQUEST_LIST,
    _b[HelpcenterPageType.REQUEST_PAGE] = HelpcenterPageNames.REQUEST_PAGE,
    _b[HelpcenterPageType.FOLLOWED_ARTICLES] = HelpcenterPageNames.FOLLOWED_ARTICLES,
    _b);
//# sourceMappingURL=domain.js.map